/*
 * 詳細画面パーツ
 * 単体選択
 */
<template>
<tr class="tr-td-control">
	<!-- 単体選択 -->
	<td class="td-dataname">
		<div class="layout-left"><!-- 空白除けコメントアウト
			-->{{r_title}}
		</div>
		<div v-if="edit_right && r_is_require" class="layout-right">
			<font class="text-red">＊</font>
		</div>
	</td>
	<td class="td-data">
		<div class="div-area" v-if="edit_right" >
			<el-form onsubmit="return false;" :model="m_ruleForm" :rules="m_validationText" ref="valid_target" >
				<el-form-item prop="disp_text">
					<c-inputedit
						class="select-text"
						:r_input_class="r_is_class_modify ? createEditClassType(m_ruleForm.disp_text) : ''"
						r_type="read-only"
						:r_disabled="r_disabled"
						v-model="m_ruleForm.disp_text"
					></c-inputedit>
					<c-butsearchinfo v-if="r_btn_visible"
						ref="b_company"
						:r_butName="r_messages.select_btn"
						:r_dialogTitle="r_dialogTitle"
						:r_disabled="r_disabled"
						class="but-search"
						style="display:inline-block; position:absolute; top:0; margin-left:5px;"
						@event_master_disp="onMasterSelectDisp">
						<!-- 単一選択画面 -->
						<components
							:is="r_dialog_component_name"
							:r_type="r_type"
							:r_param="r_param"
							:r_info="m_ruleForm.objValue"
							:r_messages="r_messages"
							:r_settings="r_settings"
							:r_code="value"
							:r_code_name="r_code_name"
							:r_is_no_setting="r_is_no_setting"
							:r_select_component_name="r_select_component_name"
							:r_list_header="list_header"
							:r_list_items="list_items"
							:r_initial_sortID="r_initial_sortID"
							:r_is_model_dependent="r_is_model_dependent"
							:r_disp="r_disp"
							:class="r_component_class"
							@event_change="onChangeDepartments">
						</components>
					</c-butsearchinfo>
				</el-form-item>
			</el-form >
		</div>
		<div class="div-area" v-else ><!-- 空白除けコメントアウト
		-->{{m_ruleForm.disp_text}}
		</div>
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * 呼び出しコード.<br>
	 * @module js\parts\DetailItemCode
	 * @example
	 * <c-edititemcode
	 * 	:r_messages = "r_messages"
	 * 	:r_settings = "r_settings"
	 * 	:info="m_info"
	 * 	@event_close="onClose"
	 * 	@event_btn_copy="onBtnCopy"
	 * >
	 * </c-edititemcode>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} info - 編集するデータ
	 * @param {bool} r_disp = {btn_copy:true,btn_freenumsearch:true} - ボタンを表示するか、しないか
	 **/
	export default {
		props:{
			'value':{},
			'r_title':String,
			'r_dialogTitle':String,
			'r_messages':{},
			'r_settings':{},
			'r_param':{},
			'r_disp': {},
			'r_type':[Number,String],
			'r_is_no_setting':{
				type:Boolean,
				default:false
			},
			'r_is_model_dependent':{
				type:Boolean,
				default:false
			},
			'r_dialog_component_name': {
				type: String,
				default: 'c-wndselectone'
			},
			'r_select_component_name':{
				type:String,
				default:'c-selectionifsearch',
				validator(val) {
					return val!="";
				}
			},
			'r_code_name': {
				type: String,
				default: 'text_code'
			},
			'r_disp_text':String,
			'r_disabled':{
				type:Boolean,
				default:false
			},
			'r_btn_visible':{
				type:Boolean,
				default:true
			},
			'r_list_show_data':{
				type:Array,
				default:function(){ return [] }
			},
			'r_initial_sortID': {
				type: Number,
				default: 1
			},
			'r_isChange': {
				type:Boolean,
				default: true,
			},
			// ユーザーの編集権限をチェックするか
			'r_check_editable': {
				type:Boolean,
				default: true,
			},
			// クラス操作可否
			'r_is_class_modify': {
				type: Boolean,
				default: true,
			},
			// componentクラス
			'r_component_class': {
				type: String,
				default: '',
			}
		},
		mixins: [
			require('js/common/Edit.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		data:function (){
			return{
				m_ruleForm: {disp_text:this.r_disp_text,objValue:{}},
				m_max_length: this.r_max_length,
				m_validationText:{
					disp_text: [
						{
							validator: (rule, value, callback) => {
								var errMessage = "";
								if ( this.r_is_require && value.length == 0){
									errMessage = this.r_messages.required;
								}
								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}
							},
							trigger: 'no'
						}
					],
				}
			};
		},
		created: function() {
			this.m_ruleForm.disp_text = this.r_disp_text? this.r_disp_text:"";
			this.m_isChange = false;
		},
		/**
		 * @instance
		 **/
		computed: {
			//! リストヘッダー定義
			list_header:function(){
				var arr = [];
				for ( let key in this.r_list_show_data ) {
					const item = this.r_list_show_data[key];
					arr.push({
							id: item.id,							//!< ソートID ※0:ソート無効
							name: 	item.name,			//!< 表示名
							class:	item.class,	//!< クラス名
					});
				}
				return arr;
			},
			// リストアイテム定義
			list_items: function(){
				var arr = [];
				for ( let key in this.r_list_show_data ) {
					const item = this.r_list_show_data[key];
					//! 呼び出しコード
					arr.push({
						type: item.type,				//!< タイプ指定
						class: item.type_class,		//!< クラス名
						name: item.type_name			//!< スロット名
					});
				}
				return arr;
			},
			// 編集可能か
			edit_right:function() {
				if (!this.r_check_editable) {
					return true;
				}
				if (this.r_settings.edit_right) {
					return true;
				}
				return false;
			},
		},
		watch: {
			r_disp_text: function (newValue) {
				this.m_ruleForm.disp_text = this.r_disp_text;
			},
		},
		methods: {
			setUpdate: function(is){
				this.m_isChange = is;
			},
			/**
			 * コピー元データ取得イベント <br>
			 * ******* 内部処理 *******<br>
			 * event_btn_copyでイベントを受け取り、親にevent_btn_copyイベントを投げる。 <br>
			 *
			 * @function  event_btn_copy
			 * @param {object} info - 元データ
			 * @param {object} copyInfo - コピー元データ
			 * @instance
			 */
			onChangeDepartments: function(info){
				this.$refs.b_company.onButClose();
				this.m_ruleForm.objValue = info;
				this.$emit('event_change', this.m_ruleForm.objValue);
				this.m_isChange = this.r_isChange;
			},
			/**
			 * 親コンポーネントから明示的に名称をセットする
			 */
			setDispText: function(text){
				this.m_ruleForm.disp_text = text;
			},
			onMasterSelectDisp: function(val){
				this.$emit('event_master_disp', val);
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editSelectBtnInfo.vue